// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { saveJobBoardDetailsStart } from "../../../../../../redux/slices/setting/settingsSlice";

// import {
//   Button,
//   FormFieldSet,
//   useFormHandler,
// } from "../../../../../../components";

// const AddAccountModel = ({ category, type, onCancel }) => {
//   const dispatch = useDispatch(); // ← initialize dispatch
//   const { user } = useSelector((state) => state.auth);
//   const [validationRules, setValidationRules] = useState({});
//   const initialFormData = {
//     displayName: "",
//     password: "",
//     secretKey: "",
//     clientId: "",
//     cat: "",
//     available: "",
//     downloaded: "",
//   };
//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler(initialFormData, validationRules);

//   const handleSubmit = () => {
//     const isValid = validateAllFields();
//     if (!isValid) return;

//     const payload = {
//       coll: "Integration",
//       payload: {
//         name: formData.displayName,
//         category, // numeric category
//         type, // card type
//         addedBy: user?.data?.uiid || 1,
//         config: {
//           clientId: formData.clientId,
//           clientSecret: formData.secretKey,
//           cat: formData.cat,
//           credits: { available: 0, purchased: 0, used: 0 },
//         },
//       },
//     };

//     console.log("Dispatching Payload:", payload);

//     dispatch(saveJobBoardDetailsStart(payload));

//     // // Optionally close modal
//     // onCancel();
//   };

//   useEffect(() => {
//     setValidationRules({
//       displayName: { type: "text", required: true },
//       secretKey: { type: "text", required: true },
//       cat: { type: "text", required: true },
//       clientId: { type: "text", required: true },
//     });
//   }, []);
//   console.log("Form Data:", formData);
//   console.log("type:", type);
//   console.log("category:", category);
//   return (
//     <div className="h-120">
//       <div className="flex flex-col justify-between border-1 border-gray-200 rounded-lg m-2 p-4">
//         <div className="grid grid-cols-3 gap-x-4 gap-y-5">
//           <FormFieldSet
//             title="Display Name"
//             type="text"
//             placeholder="Enter"
//             value={formData.displayName}
//             onChange={(value) => handleChange("displayName", value)}
//             error={errors.displayName}
//           />
//           {/* <FormFieldSet
//             title="Password"
//             type="text"
//             placeholder="Enter"
//             value={formData.password}
//             onChange={(value) => handleChange("password", value)}
//             error={errors.password}
//           /> */}
//           <FormFieldSet
//             title="Client ID"
//             type="text"
//             placeholder="Enter"
//             value={formData.clientId}
//             onChange={(value) => handleChange("clientId", value)}
//             error={errors.clientId}
//           />
//           <FormFieldSet
//             title="Secret Key"
//             type="text"
//             placeholder="Enter"
//             value={formData.secretKey}
//             onChange={(value) => handleChange("secretKey", value)}
//             error={errors.secretKey}
//           />

//           <FormFieldSet
//             title={category === 3 && type === 2 ? "cac" : "cat"}
//             type="text"
//             placeholder="Enter"
//             value={formData.cat}
//             onChange={(value) => handleChange("cat", value)}
//             error={errors.cat}
//           />
//           {/* <FormFieldSet
//             title="Available"
//             type="text"
//             placeholder="Enter"
//             value={formData.available}
//             onChange={(value) => handleChange("available", value)}
//             error={errors.available}
//           /> */}
//           {/* <FormFieldSet
//             title="Downloaded"
//             type="text"
//             placeholder="Enter"
//             value={formData.downloaded}
//             onChange={(value) => handleChange("downloaded", value)}
//             error={errors.downloaded}
//           /> */}
//         </div>

//         <div className="flex gap-3 self-end pt-4 mt-10 mr-10">
//           <Button title={"Cancel"} variant="outlined" onClick={onCancel} />
//           <Button title={"Save"} onClick={handleSubmit} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddAccountModel;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveJobBoardDetailsStart } from "../../../../../../redux/slices/setting/settingsSlice";
import {
  Button,
  FormFieldSet,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import { updateSettingsIntegration } from "../../../../../../redux/slices/setting/settingApi";

const AddAccountModel = ({ category, type, onCancel,onConnect,existingData, isEditMode}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [fieldSchema, setFieldSchema] = useState([]);
  const [validationRules, setValidationRules] = useState({});
  // const initialFormData = {
  //   displayName: "",
  //   secretKey: "",
  //   clientId: "",
  //   cat: "", // will hold cat or customerAccountCode value
  // };
  const initialFormData = {
    displayName: "",
    // secretKey: "",
    // clientId: "",
    // cat: "", // will hold cat or customerAccountCode value
  };

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    initialFormData,
    validationRules
  );

  const buildPayload = (formData, category, type) => {
    let config = {};

    if (category === 11) {
      switch (type) {
        case 1: // G Suite
          config = {
            type: formData.type,
            project_id: formData.project_id,
            private_key_id: formData.private_key_id,
            private_key: formData.private_key,
            client_email: formData.client_email,
            client_id: formData.client_id,
            auth_uri: formData.auth_uri,
            token_uri: formData.token_uri,
            auth_provider_x509_cert_url: formData.auth_provider_x509_cert_url,
            client_x509_cert_url: formData.client_x509_cert_url,
            universe_domain: formData.universe_domain,
          };
          break;

        case 2: // Outlook
          config = {
            clientId: formData.clientId,
            clientSecret: formData.clientSecret,
            tenantId: formData.tenantId,
          };
          break;

        case 3: // MailGun
          config = {
            apiKey: formData.apiKey,
            domain: formData.domain,
          };
          break;

        case 4: // AWS SES
          config = {
            region: formData.region,
          };
          break;

        case 5: // Instantly
          config = {
            apiKey: formData.apiKey,
          };
          break;

        default:
          config = {};
      }
    } else if (category === 7 && type === 1) {
      config = {
        clientID: formData.clientID,
        clientSecret: formData.clientSecret,
      };
    } else {
      config = {
        clientId: formData.clientId,
        clientSecret: formData.secretKey,
        credits: { available: 0, purchased: 0, used: 0 },
      };

      if (type === 2) {
        config.customerAccountCode = formData.cat;
      } else {
        config.cat = formData.cat;
      }
    }

    return {
      coll: "Integration",
      payload: {
        name: formData.displayName,
        category,
        type,
        addedBy: user?.data?.uiid,
        config,
      },
    };
  };


  // useEffect(() => {
  //   setValidationRules({
  //     displayName: { type: "text", required: true },
  //     secretKey: { type: "text", required: true },
  //     cat: { type: "text", required: true },
  //     clientId: { type: "text", required: true },
  //   });
  // }, []);

  // const handleSubmit = () => {
  //   const isValid = validateAllFields();
  //   if (!isValid) return;

 
  //   // const config = {
  //   //   clientId: formData.clientId,
  //   //   clientSecret: formData.secretKey,
  //   //   credits: { available: 0, purchased: 0, used: 0 },
  //   // };

   
  //   // if (type === 2) {
  //   //   config.customerAccountCode = formData.cat;
  //   // } else {
  //   //   config.cat = formData.cat;
  //   // }

  //   // const payload = {
  //   //   coll: "Integration",
  //   //   payload: {
  //   //     name: formData.displayName,
  //   //     category,
  //   //     type,
  //   //     addedBy: user?.data?.uiid || 1,
  //   //     config,
  //   //   },
  //   // };
  // const payload = buildPayload(formData, category, type, user);

  // // console.log("Dispatching Payload:", payload);

  //   dispatch(saveJobBoardDetailsStart(payload));

  //   // Optionally close modal after save
  //   onCancel();
  //   // onConnect && onConnect();
  //   if (onConnect) onConnect();
  //   if (onCancel) onCancel();
  // };
  const handleSubmit = async () => {
    const isValid = validateAllFields();
    if (!isValid) return;

    const payload = buildPayload(formData, category, type, user);
    try {
      if (isEditMode && existingData?.uiid) {
        const updatePayload = {
          uiid: existingData?.uiid,
          payload: [
            {
              type: "SET",
              value: {
                name: formData.displayName,
                config: payload.payload.config, 
              },
            },
          ],
        };
        const res = await updateSettingsIntegration(updatePayload);

        if(res?.data) {
          showToast("Updated successfully!","success",2000);
        } else {
          showToast("Error while updating","error")
        }
      } else {
        dispatch(saveJobBoardDetailsStart(payload));
      }

      // Close modals
      if (onConnect) onConnect();
      if (onCancel) onCancel();
    } catch (error) {
      console.error("Error saving/updating integration:", error);
    }
  };

  useEffect(() => {
    if (category === 11) {
      let schema = [];

      switch (type) {
        case 1: // G Suite
          schema = [
            { key: "type", label: "Type", type: "text", required: true },
            { key: "project_id", label: "Project ID", type: "text", required: true },
            { key: "private_key_id", label: "Private Key ID", type: "text", required: true },
            { key: "private_key", label: "Private Key", type: "text", required: true },
            { key: "client_email", label: "Client Email", type: "text", required: true },
            { key: "client_id", label: "Client ID", type: "text", required: true },
            { key: "auth_uri", label: "Auth URI", type: "text", required: true },
            { key: "token_uri", label: "Token URI", type: "text", required: true },
            {
              key: "auth_provider_x509_cert_url",
              label: "Auth Provider Cert URL",
              type: "text", required: true
            },
            {
              key: "client_x509_cert_url",
              label: "Client Cert URL",
              type: "text", required: true
            },
            { key: "universe_domain", label: "Universe Domain", type: "text", required: true },
          ];
          break;

        case 2: // Outlook
          schema = [
            { key: "clientId", label: "Client ID", type: "text", required: true },
            { key: "clientSecret", label: "Client Secret", type: "text", required: true },
            { key: "tenantId", label: "Tenant ID", type: "text", required: true },
          ];
          break;

        case 3: // MailGun
          schema = [
            { key: "apiKey", label: "API Key", type: "text", required: true },
            { key: "domain", label: "Domain", type: "text", required: true },
          ];
          break;

        case 4: // AWS SES
          schema = [{ key: "region", label: "Region", type: "text", required: true }];
          break;

        case 5: // Instantly
          schema = [{ key: "apiKey", label: "API Key", type: "text", required: true }];
          break;

        default:
          schema = [];
      }

      setFieldSchema(schema);

      // Validation rules
      const rules = {};
      schema.forEach((f) => {
        if (f.required) {
          rules[f.key] = { type: f.type === "textarea" ? "textarea" : "text", required: true };
        }
      });
      setValidationRules(rules);

    } else if (category === 7 && type === 1) {
    const schema = [
      { key: "clientID", label: "Client ID", type: "text", required: true },
      { key: "clientSecret", label: "Client Secret", type: "text", required: true },
    ];
    setFieldSchema(schema);

    const rules = {
      displayName: { type: "text", required: true },
      clientID: { type: "text", required: true },
      clientSecret: { type: "text", required: true },
    };
    setValidationRules(rules);

  } else {
      // Default non-bulk-email fields
      const schema = [
        { key: "clientId", label: "Client ID", type: "text" },
        { key: "secretKey", label: "Secret Key", type: "text" },
        {
          key: "cat",
          label: type === 2 ? "Customer Account Code" : "CAT",
          type: "text",
        },
      ];
      setFieldSchema(schema);

      const rules = { displayName: { type: "text", required: true } };
      schema.forEach((f) => {
        rules[f.key] = { type: "text", required: true };
      });
      setValidationRules(rules);
    }
  }, [category, type]);
  useEffect(() => {
    if (isEditMode && existingData) {
      const { name, config } = existingData;

      const prefilledData = {
        displayName: name || "",
        ...config,
      };
      Object.keys(prefilledData).forEach((key) => {
        handleChange(key, prefilledData[key]);
      });
    }
  }, [isEditMode, existingData]);


  return (
    <div className="h-120">
      <div className="flex flex-col justify-between border-1 border-gray-200 rounded-lg m-2 p-4">
        <div className="grid grid-cols-3 gap-x-4 gap-y-5">
          <FormFieldSet
            title="Display Name"
            type="text"
            placeholder="Enter"
            value={formData.displayName}
            onChange={(value) => handleChange("displayName", value)}
            error={errors.displayName}
          />

          {/* <FormFieldSet
            title="Client ID"
            type="text"
            placeholder="Enter"
            value={formData.clientId}
            onChange={(value) => handleChange("clientId", value)}
            error={errors.clientId}
          />

          <FormFieldSet
            title="Secret Key"
            type="text"
            placeholder="Enter"
            value={formData.secretKey}
            onChange={(value) => handleChange("secretKey", value)}
            error={errors.secretKey}
          />

         
          <FormFieldSet
            title={type === 2 ? "Customer Account Code" : "CAT"}
            type="text"
            placeholder="Enter"
            value={formData.cat}
            onChange={(value) => handleChange("cat", value)}
            error={errors.cat}
          /> */}
          {fieldSchema.map(({ key, label, type }) => (
            <FormFieldSet
              key={key}
              title={label}
              type={type}
              placeholder="Enter"
              value={formData[key] || ""}
              onChange={(value) => handleChange(key, value)}
              error={errors[key]}
            />
          ))}
        </div>

        <div className="flex gap-3 self-end pt-4 mt-10 mr-10">
          <Button title="Cancel" variant="outlined" onClick={onCancel} />
          <Button title="Save" onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
};

export default AddAccountModel;
